import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';

declare var google;

@Component({
  selector: 'page-addzone',
  templateUrl: 'addzone.html',
})
export class AddzonePage {
  @ViewChild('mapFull2') mapElement: ElementRef;
  Title = ''
  zId = -1
  pois = []
  Groups = []
  _zname = ''
  _av = '3'
  _zType = '2'
  _groupID = '1'
  Map: any
  newZoneLayerLine = []
  newZoneLayerPoly = []
  newZoneLayerPoints = []
  towyardflag = false

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, private toastCtrl: ToastController, public alertCtrl: AlertController) {
    this.Title = dic.l["addZone"]
    this.pois = navParams.get('pois')
    this.zId = navParams.get('id')
    this._zType = (navParams.get('type') == undefined) ? '2' : navParams.get('type')
    if (this.zId + '' != '-1') {
      this._zname = navParams.get('name')
      this.loadZoneDetails()
      if (navParams.get('towyard') == '1') {
        this.towyardflag = true
      } else {
        this.towyardflag = false
      }
      if (this._zType + '' == '2')
        this.Title = dic.l["editZone"]
      else
        this.Title = dic.l["editPoly"]
    }
  }

  //

  ionViewDidLoad() {
    // console.log('ionViewDidLoad AddzonePage');
    this.loadPoiGroups()
    this.initMap()
  }

  initMap() {
    var _that = this
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
      draggable: true,
    }
    this.Map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.gn._Post('/api/gn/insertgoogleuse', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), path: this.gn.crypt('add zone') }, function () {
    })

    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < this.pois.length; i++) {
      bounds.extend({ lat: parseFloat(this.pois[i].lat), lng: parseFloat(this.pois[i].lon) });
    }
    this.Map.fitBounds(bounds);
    this.drawNewZone()

  }


  drawNewZone() {

    var _pp = []
    var _ppol = []
    for (var i = 0; i < this.pois.length; i++) {
      _pp.push({ lat: parseFloat(this.pois[i].lat), lng: parseFloat(this.pois[i].lon) })
    }

    this.clearNewZoneLayers()
    if (_pp.length > 1) {
      var _Line = new google.maps.Polyline({ path: _pp, strokeColor: '#f00', strokeOpacity: 1, strokeWeight: 2 });
      _Line.setMap(this.Map)
      this.newZoneLayerLine.push(_Line)
    }
    if (_pp.length > 2) {
      var _poly = new google.maps.Polygon({ paths: _pp, strokeWeight: 0, fillColor: '#f00', fillOpacity: 0.3 });
      _poly.setMap(this.Map)
      this.newZoneLayerPoly.push(_poly)
    }
    for (var i = 0; i < _pp.length; i++) {
      /*no*/var marker = new google.maps.Marker({
      draggable: true,
      position: _pp[i], icon: { path: google.maps.SymbolPath.CIRCLE, scale: 4, strokeColor: '#f00' }, map: this.Map
    });
      marker.tempGoran = i
      this.newZoneLayerPoints.push(marker)
      var _that = this
      google.maps.event.addListener(marker, 'dragend', function (event) {
        _that.pois[this.tempGoran] = { lon: event.latLng.lng(), lat: event.latLng.lat() }
        _that.drawNewZone()
      });
    }


  }
  clearNewZoneLayers() {


    if (this.newZoneLayerPoints.length > 0) {
      for (var j = 0; j < this.newZoneLayerPoints.length; j++) { this.newZoneLayerPoints[j].setMap(null) }
    }
    if (this.newZoneLayerLine.length > 0) {
      for (var j = 0; j < this.newZoneLayerLine.length; j++) { this.newZoneLayerLine[j].setMap(null) }
    }
    if (this.newZoneLayerPoly.length > 0) {
      for (var j = 0; j < this.newZoneLayerPoly.length; j++) { this.newZoneLayerPoly[j].setMap(null) }
    }

    this.newZoneLayerLine = []
    this.newZoneLayerPoints = []
    this.newZoneLayerPoly = []

  }


  loadZoneDetails() {
    var _that = this
    this.gn._Post('/api/gn/getzonedetails', { zid: this.gn.crypt(this.zId) }, function (_data) {
      _that._av = _data.available
      _that._zType = _data.type
      _that._groupID = _data.groupid
    })
  }

  loadPoiGroups() {
    var _that = this
    this.gn._Post('/api/gn/getpoigroups', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _data[0].name = _that.dic.l["Ungroupped"]
      _that.Groups = _data
    })
  }

  DeleteZone() {
    var _dat = {
      id: this.gn.crypt(this.zId),
    }
    var _that = this
    this.gn._Post('/api/gn/deletepoimap', _dat, function (_data) {
      if (_data.msg == 'ok') {
        var _cb1 = _that.navParams.get('cb1')
        if (_cb1 != null) {
          _cb1(_data.type)
        }
        //zone
        if (_data.type == 2)
          var _msg = _that.dic.l["succdelzone"]
        //poligon
        else
          var _msg = _that.dic.l["succdelpoly"]

        let toast = _that.toastCtrl.create({
          message: _msg,
          duration: 3000,
          position: 'top'
        });
        toast.present();
        _that.navCtrl.pop()
      } else {
        let toast = _that.toastCtrl.create({ message: _that.dic.l["containorders3"] + ': ' + _data.orders + '. ' + _that.dic.l["containorders2"], duration: 6000, position: 'top' });
        toast.present();
      }
    })
  }

  Save() {
    if (this._zname == '') {
      let toast2 = _that.toastCtrl.create({
        message: _that.dic.l["alertnozonename"],
        duration: 3000,
        position: 'top'
      });
      toast2.present();
      return
    }
    var _pois = []
    for (var i = 0; i < this.pois.length; i++) {
      _pois.push(this.pois[i].lat + " " + this.pois[i].lon)
    }
    _pois.push(this.pois[0].lat + " " + this.pois[0].lon)

    var _dat = {
      id: this.gn.crypt(this.zId),
      name: this.gn.crypt(this._zname),
      av: this.gn.crypt(this._av),
      type: this.gn.crypt(this._zType),
      gid: this.gn.crypt(this._groupID),
      uid: this.gn.crypt(this.gn.user.UserId),
      cid: this.gn.crypt(this.gn.user.ClientId),
      pois: this.gn.crypt(_pois.join(',')),
      towyard: this.towyardflag == true ? this.gn.crypt('1') : this.gn.crypt('0')
    }
    var _that = this

    this.gn._Post('/api/gn/savezone', _dat, function (_data) {
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb(_data.type)
      }
      if (_data.type + "" == "2") {
        var _msg = _that.dic.l["succaddzone"]
        if (_that.zId + '' != '-1') {
          _msg = _that.dic.l["succaddzone2"]
        }
      } else {
        var _msg = _that.dic.l["succaddpoly"]
        if (_that.zId + '' != '-1') {
          _msg = _that.dic.l["succaddpoly2"]
        }
      }

      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })
  }



  addnewgroup() {
    var _that = this
    let prompt = this.alertCtrl.create({
      title: this.dic.l["newpoigroup"],
      message: this.dic.l["newpoigroupname"],
      inputs: [
        {
          name: 'name',
          placeholder: this.dic.l["grname"]
        },
      ],
      buttons: [
        { text: this.dic.l["cancel"], handler: data => { } },
        {
          text: this.dic.l["Save"],
          handler: data => {
            // console.log(data);
            _that.gn.tfBtn = true;
            _that.gn._Post('/api/gn/addpoigrouop', { cid: _that.gn.crypt(_that.gn.user.ClientId), gname: _that.gn.crypt(data.name) }, function (_data) {
              _that.loadPoiGroups()
              _that.gn.tfBtn = false;
            })
          }
        }
      ]
    });
    prompt.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/mapview/addzone/addzone.ts